var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-special-goods-ui-custom" },
    [
      _vm.job.cargoType === "DG"
        ? _c(
            "tab-special-goods-UICustom-layout",
            { attrs: { "element-blocks": _vm.elementBlocks } },
            [
              _c(
                "div",
                {
                  staticClass: "section",
                  attrs: { slot: "viewAssociatedBusiness" },
                  slot: "viewAssociatedBusiness"
                },
                [
                  _c(
                    "div",
                    { staticClass: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.btnshowAWindow,
                              expression: "btnshowAWindow"
                            }
                          ],
                          attrs: {
                            disabled: !!_vm.previewConfig,
                            no: "1",
                            type: "primary",
                            size: "mini"
                          },
                          on: { click: _vm.showAWindowClickHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.ViewAssociatedBusiness"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm.elementDict.listOfHazardousMaterials.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "section",
                      attrs: { slot: "listOfHazardousMaterials" },
                      slot: "listOfHazardousMaterials"
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("queryJob.ListOfHazardousMaterials"))
                        )
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column"
                          }
                        },
                        [
                          _c("cargo-ag-grid", {
                            staticStyle: { width: "950px", height: "200px" },
                            attrs: {
                              "grid-options": _vm.danger.gridOptions,
                              "grid-params": _vm.danger.gridParams,
                              "column-defs": _vm.dangerColumnDefs,
                              "row-data": _vm.specialGoods
                            },
                            on: {
                              "update:gridParams": function($event) {
                                return _vm.$set(
                                  _vm.danger,
                                  "gridParams",
                                  $event
                                )
                              },
                              "update:grid-params": function($event) {
                                return _vm.$set(
                                  _vm.danger,
                                  "gridParams",
                                  $event
                                )
                              },
                              gridReady: function(params) {
                                return (_vm.danger.gridApi = params.api)
                              }
                            }
                          }),
                          _c("div", { staticStyle: { width: "100%" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  float: "left",
                                  padding: "5px 5px 5px 0"
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "3",
                                      type: "primary",
                                      disabled: !_vm.isEditing
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.addSpGoods()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SpecialGoods.Add")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      no: "4",
                                      type: "danger",
                                      disabled: !_vm.isEditing
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.delSpGoods()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SpecialGoods.Delete"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-upload",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "padding-left": "5px"
                                    },
                                    attrs: {
                                      disabled: !_vm.isEditing,
                                      action: "string",
                                      "http-request": _vm.importSpGoods,
                                      "show-file-list": false,
                                      accept: ".jpg, .jpeg, .png",
                                      "before-upload": _vm.beforeUploadSpgGoods
                                    }
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          disabled: !_vm.isEditing,
                                          type: "primary"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SpecialGoods.Import"))
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      no: "5",
                                      type: "primary",
                                      disabled: !_vm.isEditing
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.fillInSpGoods()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SpecialGoods.FillIn"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              [
                _vm.elementDict.danClassNo.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "danClassNo" }, slot: "danClassNo" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.danClassNo.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.danClassNo.label
                          },
                          slot: "label"
                        }),
                        !_vm.dangerousInputMode
                          ? _c("el-input", {
                              attrs: { no: "6", disabled: !_vm.isEditing },
                              model: {
                                value: _vm.editObj.danClassNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.editObj, "danClassNo", $$v)
                                },
                                expression: "editObj.danClassNo"
                              }
                            })
                          : _vm._e(),
                        _vm.dangerousInputMode
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  no: "7",
                                  disabled:
                                    !_vm.isEditing ||
                                    !_vm.elementDict.danClassNo.writable,
                                  placeholder: !_vm.isEditing
                                    ? ""
                                    : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                  clearable: "",
                                  filterable: ""
                                },
                                model: {
                                  value: _vm.editObj.danClassNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editObj, "danClassNo", $$v)
                                  },
                                  expression: "editObj.danClassNo"
                                }
                              },
                              _vm._l(_vm.danClassNos, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: _vm.isZh
                                      ? item.chineseName
                                      : item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.secondarySpecialGoods.viewable
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { slot: "secondarySpecialGoods" },
                        slot: "secondarySpecialGoods"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.secondarySpecialGoods.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.secondarySpecialGoods.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          attrs: {
                            no: "8",
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.secondarySpecialGoods.writable
                          },
                          model: {
                            value: _vm.editObj.secondarySpecialGoods,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.editObj,
                                "secondarySpecialGoods",
                                $$v
                              )
                            },
                            expression: "editObj.secondarySpecialGoods"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.danUNNo.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "danUNNo" }, slot: "danUNNo" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.danUNNo.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.danUNNo.label
                          },
                          slot: "label"
                        }),
                        _c(
                          "el-select",
                          {
                            ref: "danUNNo",
                            attrs: {
                              no: "9",
                              disabled:
                                !_vm.isEditing ||
                                !_vm.elementDict.danUNNo.writable,
                              placeholder: !_vm.isEditing
                                ? ""
                                : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                              filterable: "",
                              clearable: "",
                              "allow-create": true
                            },
                            on: {
                              blur: function($event) {
                                return _vm.txtdDnUNNoFocusOutHandler()
                              }
                            },
                            model: {
                              value: _vm.editObj.danUNNo,
                              callback: function($$v) {
                                _vm.$set(_vm.editObj, "danUNNo", $$v)
                              },
                              expression: "editObj.danUNNo"
                            }
                          },
                          _vm._l(_vm.dangerousGoods, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.code, value: item.code }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.danPacking.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "danPacking" }, slot: "danPacking" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.danPacking.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.danPacking.label
                          },
                          slot: "label"
                        }),
                        !_vm.dangerousInputMode
                          ? _c("el-input", {
                              attrs: { no: "10", disabled: !_vm.isEditing },
                              model: {
                                value: _vm.editObj.danPacking,
                                callback: function($$v) {
                                  _vm.$set(_vm.editObj, "danPacking", $$v)
                                },
                                expression: "editObj.danPacking"
                              }
                            })
                          : _vm._e(),
                        _vm.dangerousInputMode
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  no: "11",
                                  disabled:
                                    !_vm.isEditing ||
                                    !_vm.elementDict.danPacking.writable,
                                  placeholder: !_vm.isEditing
                                    ? ""
                                    : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.editObj.danPacking,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editObj, "danPacking", $$v)
                                  },
                                  expression: "editObj.danPacking"
                                }
                              },
                              _vm._l(_vm.packingGoods, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: _vm.isZh
                                      ? item.chineseName
                                      : item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.danLable.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "danLable" }, slot: "danLable" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.danLable.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.danLable.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          attrs: {
                            no: "12",
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.danLable.writable
                          },
                          model: {
                            value: _vm.editObj.danLable,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "danLable", $$v)
                            },
                            expression: "editObj.danLable"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.danEMS.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "danEMS" }, slot: "danEMS" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.danEMS.isRequire ? "blue" : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.danEMS.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          attrs: {
                            no: "13",
                            disabled:
                              !_vm.isEditing || !_vm.elementDict.danEMS.writable
                          },
                          model: {
                            value: _vm.editObj.danEMS,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "danEMS", $$v)
                            },
                            expression: "editObj.danEMS"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.danPoint.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "danPoint" }, slot: "danPoint" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.danPoint.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.danPoint.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          staticStyle: {
                            width: "85%",
                            display: "inline-block"
                          },
                          attrs: { no: "14", disabled: !_vm.isEditing },
                          model: {
                            value: _vm.editObj.danPoint,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "danPoint", $$v)
                            },
                            expression: "editObj.danPoint"
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              width: "15%",
                              display: "inline-block"
                            },
                            attrs: {
                              disabled:
                                !_vm.isEditing ||
                                !_vm.elementDict.danPoint.writable,
                              no: "flashPointUnit",
                              placeholder: ""
                            },
                            model: {
                              value: _vm.editObj.flashPointUnit,
                              callback: function($$v) {
                                _vm.$set(_vm.editObj, "flashPointUnit", $$v)
                              },
                              expression: "editObj.flashPointUnit"
                            }
                          },
                          _vm._l(_vm.flashPointUnitArray, function(
                            item,
                            index
                          ) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.temperatureUnit.viewable &&
                _vm.dangerousInputMode
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { slot: "temperatureUnit" },
                        slot: "temperatureUnit"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.temperatureUnit.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.temperatureUnit.label
                          },
                          slot: "label"
                        }),
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "15",
                              disabled:
                                !_vm.isEditing ||
                                !_vm.elementDict.temperatureUnit.writable,
                              placeholder: !_vm.isEditing
                                ? ""
                                : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                              clearable: false
                            },
                            model: {
                              value: _vm.editObj.temperatureUnit,
                              callback: function($$v) {
                                _vm.$set(_vm.editObj, "temperatureUnit", $$v)
                              },
                              expression: "editObj.temperatureUnit"
                            }
                          },
                          _vm._l(_vm.temperatureUnits, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.danIsolation.viewable
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "bold",
                        attrs: { slot: "danIsolation" },
                        slot: "danIsolation"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.danIsolation.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.danIsolation.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          attrs: {
                            no: "16",
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.danIsolation.writable
                          },
                          model: {
                            value: _vm.editObj.danIsolation,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "danIsolation", $$v)
                            },
                            expression: "editObj.danIsolation"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.danMfagNo.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "danMfagNo" }, slot: "danMfagNo" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.danMfagNo.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.danMfagNo.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          attrs: {
                            no: "17",
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.danMfagNo.writable
                          },
                          model: {
                            value: _vm.editObj.danMfagNo,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "danMfagNo", $$v)
                            },
                            expression: "editObj.danMfagNo"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.dan24man.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "dan24man" }, slot: "dan24man" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.dan24man.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.dan24man.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          attrs: {
                            no: "18",
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.dan24man.writable
                          },
                          model: {
                            value: _vm.editObj.dan24man,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "dan24man", $$v)
                            },
                            expression: "editObj.dan24man"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.dan24tel.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "dan24tel" }, slot: "dan24tel" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.dan24tel.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.dan24tel.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          attrs: {
                            no: "19",
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.dan24tel.writable
                          },
                          model: {
                            value: _vm.editObj.dan24tel,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "dan24tel", $$v)
                            },
                            expression: "editObj.dan24tel"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.email.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "email" }, slot: "email" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.email.isRequire ? "blue" : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.email.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          attrs: {
                            no: "email",
                            disabled:
                              !_vm.isEditing || !_vm.elementDict.email.writable
                          },
                          model: {
                            value: _vm.editObj.email,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "email", $$v)
                            },
                            expression: "editObj.email"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.fax.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "fax" }, slot: "fax" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.fax.isRequire ? "blue" : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.fax.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          attrs: {
                            no: "fax",
                            disabled:
                              !_vm.isEditing || !_vm.elementDict.fax.writable
                          },
                          model: {
                            value: _vm.editObj.fax,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "fax", $$v)
                            },
                            expression: "editObj.fax"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.responsibleParty.viewable
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { slot: "responsibleParty" },
                        slot: "responsibleParty"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.responsibleParty.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.responsibleParty.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          staticStyle: { width: "215px" },
                          attrs: {
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.responsibleParty.writable,
                            no: "20"
                          },
                          model: {
                            value: _vm.editObj.responsibleParty,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "responsibleParty", $$v)
                            },
                            expression: "editObj.responsibleParty"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.hsCode.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "hsCode" }, slot: "hsCode" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.hsCode.isRequire ? "blue" : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.hsCode.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          staticStyle: { width: "215px" },
                          attrs: {
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.hsCode.writable,
                            no: "21"
                          },
                          model: {
                            value: _vm.editObj.hsCode,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "hsCode", $$v)
                            },
                            expression: "editObj.hsCode"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.danPickTime.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "danPickTime" }, slot: "danPickTime" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.danPickTime.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.danPickTime.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          staticStyle: { width: "215px" },
                          attrs: {
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.danPickTime.writable,
                            no: "22"
                          },
                          model: {
                            value: _vm.editObj.danPickTime,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "danPickTime", $$v)
                            },
                            expression: "editObj.danPickTime"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.danSeaPullution.viewable
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { slot: "danSeaPullution" },
                        slot: "danSeaPullution"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.danSeaPullution.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.danSeaPullution.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          staticStyle: { width: "215px" },
                          attrs: {
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.danSeaPullution.writable,
                            no: "23",
                            placeholder: !_vm.isEditing
                              ? ""
                              : _vm.$t("SpecialGoods.OnlyEnterYN")
                          },
                          on: { change: _vm.limitInput },
                          model: {
                            value: _vm.editObj.danSeaPullution,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "danSeaPullution", $$v)
                            },
                            expression: "editObj.danSeaPullution"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.correctTransportName.viewable
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { slot: "correctTransportName" },
                        slot: "correctTransportName"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.correctTransportName.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.correctTransportName.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          staticStyle: { width: "215px" },
                          attrs: {
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.correctTransportName.writable,
                            no: "24"
                          },
                          model: {
                            value: _vm.editObj.correctTransportName,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "correctTransportName", $$v)
                            },
                            expression: "editObj.correctTransportName"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.grossWeight.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "grossWeight" }, slot: "grossWeight" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.grossWeight.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.grossWeight.label
                          },
                          slot: "label"
                        }),
                        _c("el-input-number", {
                          staticStyle: { width: "215px" },
                          attrs: {
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.grossWeight.writable,
                            no: "25",
                            min: 0,
                            max: 999999999999,
                            precision: 3,
                            "controls-position": "right"
                          },
                          model: {
                            value: _vm.editObj.grossWeight,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "grossWeight", $$v)
                            },
                            expression: "editObj.grossWeight"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.neatWeight.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "neatWeight" }, slot: "neatWeight" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.neatWeight.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.neatWeight.label
                          },
                          slot: "label"
                        }),
                        _c("el-input-number", {
                          staticStyle: { width: "215px" },
                          attrs: {
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.neatWeight.writable,
                            no: "26",
                            min: 0,
                            max: 999999999999,
                            precision: 3,
                            "controls-position": "right"
                          },
                          model: {
                            value: _vm.editObj.neatWeight,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "neatWeight", $$v)
                            },
                            expression: "editObj.neatWeight"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.outerPackagingType.viewable
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { slot: "outerPackagingType" },
                        slot: "outerPackagingType"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.outerPackagingType.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.outerPackagingType.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          style: _vm.isEditing ? "width:170px" : "width:215px",
                          attrs: {
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.outerPackagingType.writable,
                            no: "27"
                          },
                          model: {
                            value: _vm.editObj.outerPackagingType,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "outerPackagingType", $$v)
                            },
                            expression: "editObj.outerPackagingType"
                          }
                        }),
                        _vm.isEditing
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "el-button el-button--primary el-button--mini",
                                staticStyle: {
                                  "min-width": "40px!important",
                                  "margin-left": "2px"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.queryDangerousGoodPackageHandle(
                                      "outerPackagingType"
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "el-icon-search" })]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.outerPackagingQuantity.viewable
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { slot: "outerPackagingQuantity" },
                        slot: "outerPackagingQuantity"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.outerPackagingQuantity
                            .isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.outerPackagingQuantity.label
                          },
                          slot: "label"
                        }),
                        _c("el-input-number", {
                          staticStyle: { width: "215px" },
                          attrs: {
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.outerPackagingQuantity.writable,
                            no: "28",
                            min: 0,
                            max: 999999999999,
                            "controls-position": "right"
                          },
                          model: {
                            value: _vm.editObj.outerPackagingQuantity,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.editObj,
                                "outerPackagingQuantity",
                                $$v
                              )
                            },
                            expression: "editObj.outerPackagingQuantity"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.innerPackagingType.viewable
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { slot: "innerPackagingType" },
                        slot: "innerPackagingType"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.innerPackagingType.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.innerPackagingType.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          style: _vm.isEditing ? "width:170px" : "width:215px",
                          attrs: {
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.innerPackagingType.writable,
                            no: "29"
                          },
                          model: {
                            value: _vm.editObj.innerPackagingType,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "innerPackagingType", $$v)
                            },
                            expression: "editObj.innerPackagingType"
                          }
                        }),
                        _vm.isEditing
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "el-button el-button--primary el-button--mini",
                                staticStyle: {
                                  "min-width": "40px!important",
                                  "margin-left": "2px"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.queryDangerousGoodPackageHandle(
                                      "innerPackagingType"
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "el-icon-search" })]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.innerPackagingQuantity.viewable
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { slot: "innerPackagingQuantity" },
                        slot: "innerPackagingQuantity"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.innerPackagingQuantity
                            .isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.innerPackagingQuantity.label
                          },
                          slot: "label"
                        }),
                        _c("el-input-number", {
                          staticStyle: { width: "215px" },
                          attrs: {
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.innerPackagingQuantity.writable,
                            no: "30",
                            min: 0,
                            max: 999999999999,
                            precision: 0,
                            "controls-position": "right"
                          },
                          model: {
                            value: _vm.editObj.innerPackagingQuantity,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.editObj,
                                "innerPackagingQuantity",
                                $$v
                              )
                            },
                            expression: "editObj.innerPackagingQuantity"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.remark.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "remark" }, slot: "remark" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.remark.isRequire ? "blue" : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.remark.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          staticStyle: { width: "215px" },
                          attrs: {
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.remark.writable,
                            no: "31",
                            type: "textarea",
                            rows: 2
                          },
                          model: {
                            value: _vm.editObj.remark,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "remark", $$v)
                            },
                            expression: "editObj.remark"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.packingCode.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "packingCode" }, slot: "packingCode" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.packingCode.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.packingCode.label
                          },
                          slot: "label"
                        }),
                        _c("el-input", {
                          staticStyle: { width: "215px" },
                          attrs: {
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.packingCode.writable,
                            no: "32"
                          },
                          model: {
                            value: _vm.editObj.packingCode,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "packingCode", $$v)
                            },
                            expression: "editObj.packingCode"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.hazardForm &&
                _vm.elementDict.hazardForm.viewable
                  ? _c(
                      "el-form-item",
                      { attrs: { slot: "hazardForm" }, slot: "hazardForm" },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.hazardForm.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.hazardForm.label
                          },
                          slot: "label"
                        }),
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "215px" },
                            attrs: {
                              disabled:
                                !_vm.isEditing ||
                                !_vm.elementDict.hazardForm.writable,
                              no: "hazardForm",
                              placeholder: ""
                            },
                            model: {
                              value: _vm.editObj.hazardForm,
                              callback: function($$v) {
                                _vm.$set(_vm.editObj, "hazardForm", $$v)
                              },
                              expression: "editObj.hazardForm"
                            }
                          },
                          _vm._l(_vm.hazardFormArray, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.emergencyReportingTime &&
                _vm.elementDict.emergencyReportingTime.viewable
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { slot: "emergencyReportingTime" },
                        slot: "emergencyReportingTime"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.emergencyReportingTime
                            .isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.emergencyReportingTime.label
                          },
                          slot: "label"
                        }),
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "emergencyReportingTime",
                            disabled:
                              !_vm.isEditing ||
                              !_vm.elementDict.emergencyReportingTime.writable,
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            format: "yyyy-MM-dd HH:mm"
                          },
                          model: {
                            value: _vm.editObj.emergencyReportingTime,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.editObj,
                                "emergencyReportingTime",
                                $$v
                              )
                            },
                            expression: "editObj.emergencyReportingTime"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              _vm.elementDict.containerInfo.viewable
                ? _c(
                    "div",
                    {
                      staticClass: "section",
                      attrs: { slot: "containerInfo" },
                      slot: "containerInfo"
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo")))
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column"
                          }
                        },
                        [
                          _c("div", { staticStyle: { padding: "5px 0" } }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "33",
                                      disabled:
                                        !!_vm.previewConfig || _vm.isEditing,
                                      type: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.linkUsageClickHandler()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.AddPackingInfo"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "34",
                                      disabled:
                                        !!_vm.previewConfig || _vm.isEditing,
                                      type: "danger"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.delLinkUsageClickHandler()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.RemovePackingInfo")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  flex: "1",
                                  display: "flex",
                                  "justify-content": "flex-end",
                                  "padding-right": "100px"
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "55",
                                      disabled: !_vm.isEditing,
                                      type: "primary"
                                    },
                                    on: { click: _vm.handleAutoDistribute }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.AutoAllocation"))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _c("cargo-ag-grid", {
                            staticStyle: { width: "100%", height: "220px" },
                            attrs: {
                              no: "35",
                              "config-module": "20000",
                              "grid-options": _vm.box.gridOptions,
                              "grid-params": _vm.box.gridParams,
                              "column-defs": _vm.boxColumnDefs,
                              "row-data": _vm.containerUsages
                            },
                            on: {
                              "update:gridParams": function($event) {
                                return _vm.$set(_vm.box, "gridParams", $event)
                              },
                              "update:grid-params": function($event) {
                                return _vm.$set(_vm.box, "gridParams", $event)
                              },
                              gridReady: function(params) {
                                return (_vm.box.gridApi = params.api)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm.job.cargoType === "GOH"
        ? _c("div", { staticClass: "section" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("SpecialGoods.GOH")))
            ]),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "flex-direction": "row" } },
                  [
                    _c("span", { staticStyle: { width: "100px" } }, [
                      _vm._v(_vm._s(_vm.$t("SpecialGoods.Tier")))
                    ]),
                    _c("span", { staticStyle: { width: "190px" } }, [
                      _vm._v(_vm._s(_vm.$t("SpecialGoods.Hanger")))
                    ]),
                    _c("span", { staticStyle: { width: "190px" } }, [
                      _vm._v(_vm._s(_vm.$t("SpecialGoods.Ropes")))
                    ]),
                    _c("span", { staticStyle: { width: "190px" } }, [
                      _vm._v(_vm._s(_vm.$t("SpecialGoods.Knots")))
                    ])
                  ]
                ),
                _c(
                  "div",
                  { staticStyle: { display: "flex", "flex-direction": "row" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "90px", "margin-right": "10px" },
                      attrs: { no: "36", disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.gohTier,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "gohTier", $$v)
                        },
                        expression: "editObj.gohTier"
                      }
                    }),
                    _c("el-input", {
                      staticStyle: { width: "180px", "margin-right": "10px" },
                      attrs: { no: "37", disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.gohHanger,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "gohHanger", $$v)
                        },
                        expression: "editObj.gohHanger"
                      }
                    }),
                    _c("el-input", {
                      staticStyle: { width: "180px", "margin-right": "10px" },
                      attrs: { no: "38", disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.gohRopes,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "gohRopes", $$v)
                        },
                        expression: "editObj.gohRopes"
                      }
                    }),
                    _c("el-input", {
                      staticStyle: { width: "180px" },
                      attrs: { no: "39", disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.gohKnots,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "gohKnots", $$v)
                        },
                        expression: "editObj.gohKnots"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "row",
                      "margin-top": "10px"
                    }
                  },
                  [
                    _c("span", { staticStyle: { width: "100px" } }, [
                      _vm._v(_vm._s(_vm.$t("SpecialGoods.ReformCost")))
                    ]),
                    _c("el-input", {
                      staticStyle: { width: "180px" },
                      attrs: { no: "40", disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.gohReformCost,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "gohReformCost", $$v)
                        },
                        expression: "editObj.gohReformCost"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.job.cargoType === "RF",
              expression: "job.cargoType==='RF'"
            }
          ],
          staticClass: "section"
        },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("SpecialGoods.Reefer")))
          ]),
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "column" } },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "95px",
                    "label-position": "left"
                  }
                },
                [
                  _c("el-form-item", [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.$t("SpecialGoods.humidity")))]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("SpecialGoods.HumidityToolTip"),
                              placement: "right-end"
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                padding: "5px 0",
                                "vertical-align": "bottom"
                              },
                              attrs: {
                                src: _vm.humidityToolTip,
                                width: "18",
                                height: "28"
                              }
                            })
                          ]
                        ),
                        _c("el-input", {
                          staticStyle: { width: "160px" },
                          attrs: {
                            no: "41",
                            maxlength: 8,
                            disabled: !_vm.isEditing
                          },
                          model: {
                            value: _vm.editObj.reefHumidity,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "reefHumidity", $$v)
                            },
                            expression: "editObj.reefHumidity"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.ventilation") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "42", disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.reefVentilation,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "reefVentilation", $$v)
                          },
                          expression: "editObj.reefVentilation"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "95px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SetTemperature") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "43", disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.reefTemperature,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "reefTemperature", $$v)
                          },
                          expression: "editObj.reefTemperature"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.MinimumTemperature") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "44", disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.reefLowestTemp,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "reefLowestTemp", $$v)
                          },
                          expression: "editObj.reefLowestTemp"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.MaximumTemperature") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "45", disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.reefHighestTemp,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "reefHighestTemp", $$v)
                          },
                          expression: "editObj.reefHighestTemp"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "95px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.ContainerYard") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "46", disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.reefContainerYard,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "reefContainerYard", $$v)
                          },
                          expression: "editObj.reefContainerYard"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SpecialGoods.TemperatureUnit") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "160px" },
                          attrs: {
                            no: "47",
                            disabled: !_vm.isEditing,
                            clearable: false
                          },
                          model: {
                            value: _vm.editObj.temperatureUnit,
                            callback: function($$v) {
                              _vm.$set(_vm.editObj, "temperatureUnit", $$v)
                            },
                            expression: "editObj.temperatureUnit"
                          }
                        },
                        _vm._l(_vm.temperatureUnits, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "95px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.PortForReturningContainer")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "48", disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.reefDeliverTime,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "reefDeliverTime", $$v)
                          },
                          expression: "editObj.reefDeliverTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "95px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SpecialGoods.PTI") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "49", disabled: !_vm.isEditing },
                        model: {
                          value: _vm.editObj.reefPTI,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "reefPTI", $$v)
                          },
                          expression: "editObj.reefPTI"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.job.cargoType === "BB",
              expression: "job.cargoType==='BB'"
            }
          ],
          staticClass: "section"
        },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.NonStandardContainer")))
          ]),
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "column" } },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "40px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OverFront") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "50",
                          controls: false,
                          min: 0,
                          precision: 0,
                          disabled: !_vm.isEditing
                        },
                        model: {
                          value: _vm.editObj.overFront,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "overFront", $$v)
                          },
                          expression: "editObj.overFront"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OverBack") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "51",
                          controls: false,
                          min: 0,
                          precision: 0,
                          disabled: !_vm.isEditing
                        },
                        model: {
                          value: _vm.editObj.overBack,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "overBack", $$v)
                          },
                          expression: "editObj.overBack"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OverHeight") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "52",
                          controls: false,
                          min: 0,
                          precision: 0,
                          disabled: !_vm.isEditing
                        },
                        model: {
                          value: _vm.editObj.overHeight,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "overHeight", $$v)
                          },
                          expression: "editObj.overHeight"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "40px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OverLeft") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "53",
                          controls: false,
                          min: 0,
                          precision: 0,
                          disabled: !_vm.isEditing
                        },
                        model: {
                          value: _vm.editObj.overLeft,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "overLeft", $$v)
                          },
                          expression: "editObj.overLeft"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OverRight") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "54",
                          controls: false,
                          min: 0,
                          precision: 0,
                          disabled: !_vm.isEditing
                        },
                        model: {
                          value: _vm.editObj.overRight,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "overRight", $$v)
                          },
                          expression: "editObj.overRight"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("special-goods-container-usage-dialog", {
        attrs: {
          visible: _vm.containerUsageDialog.visible,
          "job-uuid": _vm.job.uuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.containerUsageDialog, "visible", $event)
          },
          linkUsagesEventHandler: _vm.linkUsagesEventHandler
        }
      }),
      _c("special-goods-dialog", {
        attrs: {
          visible: _vm.specialGoodsDialog.visible,
          "a-data": _vm.specialGoodsDialog.aData,
          "o-job": _vm.specialGoodsDialog.oJob,
          job: _vm.specialGoodsDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.specialGoodsDialog, "visible", $event)
          },
          refreshCache: _vm.refreshCache
        }
      }),
      _c("imdg-code-select-dialog", {
        attrs: {
          visible: _vm.imdgCodeSelDialog.visible,
          "imdg-codes": _vm.imdgCodeSelDialog.imdgCodes
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.imdgCodeSelDialog, "visible", $event)
          },
          onImdgCodeSelSucceed: _vm.onImdgCodeSelSucceed
        }
      }),
      _c("dangerous-good-package-dialog", {
        attrs: {
          visible: _vm.dangerousGoodsDialog.visible,
          type: _vm.dangerousGoodsDialog.type
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.dangerousGoodsDialog, "visible", $event)
          },
          dangerousGoodPackage: _vm.dangerousGoodPackageCallBack,
          close: function($event) {
            _vm.dangerousGoodsDialog.visible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }